import {Component, OnInit} from '@angular/core';
import {PaneBackButtonComponent} from "../pane-back-button/pane-back-button.component";
import {ImageCropperComponent} from "ngx-smart-cropper";
import {FilesService} from "../../services/files/files.service";
import {Router} from "@angular/router";
import {UsersService} from "../../services/users.service";
import * as AuthSelectors from "../../state/auth/auth.selector";
import {Store} from "@ngrx/store";
import {User} from "../../auth/primitives/user";

@Component({
  selector: 'edit-profile-crop-image',
  standalone: true,
    imports: [
        PaneBackButtonComponent,
      ImageCropperComponent
    ],
  templateUrl: './edit-profile-crop-image.component.html',
  styleUrl: './edit-profile-crop-image.component.scss'
})
export class EditProfileCropImageComponent implements OnInit {
  croppedImage = '';
  imageSource: string | null = null;
  fileId: string
  user: User

  constructor(
      private fileService: FilesService,
      private router: Router,
      private userService: UsersService,
      private store: Store
  ) {
    this.imageSource = this.fileService.getBlob()

    this.store.select(AuthSelectors.selectUser).subscribe((user) => {
      this.user = user
    })
  }

  // onFileChange(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (!input.files?.length) return;
  //
  //   const file = input.files[0];
  //   const reader = new FileReader();
  //   reader.onload = (e: any) => (this.imageSource = e.target.result);
  //   reader.readAsDataURL(file);
  // }

  async ngOnInit() {
    if (!this.imageSource) {
      await this.back()
    }
  }

  async back() {
    this.croppedImage = '';
    this.imageSource = null;
    await this.router.navigate([{outlets: {'right-pane': "profile-edit"}}])
  }

  async loadImageFailed() {
    alert("Failed to load image")
    await this.back()
  }

  async updateUser() {
    await this.userService.updateUser({
      displayName: this.user.display_name,
      tagLine: this.user.tag_line,
      profileImageId: this.fileId
    })
  }

  async imageCropped(event: string) {
    if (!event) {
      await this.back()
      return
    }
    this.croppedImage = event;
    const fileIdToUpload = await this.fileService.getServerFileIdForNewBlob(
        "profile-image",
        "image/jpeg",
        this.croppedImage.length
    );
    this.fileId = fileIdToUpload;
    await this.fileService.uploadBlob(
        fileIdToUpload,
        "profile-image",
        "image/jpeg",
        this.croppedImage,
        true, 1000
    );
    await this.updateUser()
    await this.back()
  }
}
